import { first, last, uniq } from "lodash";
import { dictionaryService } from "../../../dataFlow";
import { useCalendarDate, useDictionary, useDictionaryItem, useParameter } from "../../../shared";
import { SLIDE_NUMBER } from "../constants";

const MONTH_FREQUENCY = 4;

export function useSlideTitle() {
  const [calendar] = useParameter<number[]>("@calendar");
  const monthes = calendar?.filter(e => MONTH_FREQUENCY === +String(e)[0]) || [];
  const [startDateId, endDateId] = [first, last].map(f => (f as any)(monthes) as number);
  const startDate = useCalendarDate(startDateId);
  const endDate = useCalendarDate(endDateId);
  const dates = [startDate, endDate].filter(Boolean) as Date[];
  const formatter = Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' });
  const dateLabel = uniq(dates.map(formatter.format)).join(' - ').toLowerCase();
  return `Crop Price Index ${(dateLabel ? `(${dateLabel})` : '')}`;
}